import { render, staticRenderFns } from "./StageTeam.vue?vue&type=template&id=5a89c472&scoped=true&"
import script from "./StageTeam.vue?vue&type=script&lang=js&"
export * from "./StageTeam.vue?vue&type=script&lang=js&"
import style0 from "./StageTeam.vue?vue&type=style&index=0&id=5a89c472&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a89c472",
  null
  
)

export default component.exports